// extracted by mini-css-extract-plugin
export default {"root":"DataSourceHeader_root__vL8ax","chips":"DataSourceHeader_chips__2XcP3"};